import { FC, memo, ReactElement } from 'react';

import { useAppPagination } from '@/common/hooks';
import { FallbackedLayout } from '@/common/layouts';

import { useGetAllSearchConsoleAnalyticsDomainsQuery } from '@/modules/Domains';

import { SearchConsoleAnalyticsListView } from './SearchConsoleAnalyticsListView';

interface Props {
  siteId: string;
}

export const SearchConsoleAnalyticsListContainer: FC<Props> = memo(({ siteId }) => {
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const {
    data: sitemapDomainsData,
    error: sitemapDomainsError,
    isLoading: isSitemapDomainsLoading,
    isFetching: isSitemapDomainsFetching,
    isError: isSitemapDomainsError
  } = useGetAllSearchConsoleAnalyticsDomainsQuery(siteId, { page: currentPage })({
    enabled: !!siteId
  });

  return (
    <FallbackedLayout
      isLoading={ isSitemapDomainsLoading }
      error={ sitemapDomainsError }
      isError={ isSitemapDomainsError }
      data={ sitemapDomainsData }
    >
      { (sitemapDomainsList): ReactElement => (
        <SearchConsoleAnalyticsListView
          currentPage={ currentPage }
          sitemapDomainsItems={ sitemapDomainsList.items }
          sitemapDomainsTotalItems={ sitemapDomainsList.meta.totalItems }
          sitemapDomainsItemsPerPage={ sitemapDomainsList.meta.itemsPerPage }
          isLoading={ isSitemapDomainsFetching }
          handleChangePage={ handleChangePage }
        />
      ) }
    </FallbackedLayout>
  );
});
